import { render } from "./IntentsTabsLayout.vue?vue&type=template&id=0a4d0e08&scoped=true&lang=pug"
import script from "./IntentsTabsLayout.vue?vue&type=script&lang=js"
export * from "./IntentsTabsLayout.vue?vue&type=script&lang=js"

import "./IntentsTabsLayout.vue?vue&type=style&index=0&id=0a4d0e08&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a4d0e08"]])

export default __exports__